var _path;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

var SvgBorder2TopLeft = function SvgBorder2TopLeft(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 231,
    height: 191,
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M1 190.25V31C1 14.431 14.43 1 31 1H230.5",
    stroke: "#000"
  })));
};

export default SvgBorder2TopLeft;